import React, {useState} from 'react'
import {Box, Divider, Paper, Tooltip, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import clsx from 'clsx';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown'
import Tr from 'translations/Translations';
import ExportJedzButtons from "./ExportJedzButtons";
import WarningIcon from "@material-ui/icons/Warning";
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
    root: {
        '&>*:nth-child(1)': {
            flexGrow: 1,
        }
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    marginLeft: {
        marginLeft: theme.spacing(2),
    },
    buttonRow: {
        '& > *': {
            marginLeft: theme.spacing(1),
        },
        whiteSpace: 'nowrap',
    },
    title: {
        padding: '10px 0'
    },
    padding: {
        padding: theme.spacing(4)
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    arrow: {
        padding: theme.spacing(1),
    }
})

function DealingJedzSection(
    {
        classes,
        index,
        idPrefix,
        dealingId,
        demandId,
        setConfirmPopupData,
        title,
        formikProps,
        children,
    }) {
    const [open, setOpen] = useState(false);
    const error = getObjectValue(`${idPrefix}.qualifications`, formikProps.errors, false);

    const getTitleComponent = () => (
        <Box
            className={clsx(
                classes.marginLeft,
                classes.cursorPointer
            )}
            component='span'
            fontWeight='fontWeightBold'
            onClick={() => setOpen(!open)}
        >
            {title}
        </Box>
    )
    return (
        <Paper
            elevation={0}
        >
            <GridBlock
                wrap='nowrap'
                alignItems='center'
                className={classes.root}
            >
                <div>
                    <Typography
                        variant='body1'
                        className={classes.title}
                    >
                        {index + 1}.
                        {getTitleComponent()}
                    </Typography>
                </div>
                {error && <Tooltip title={Tr('complete_missing_data')} placement="top">
                    <WarningIcon color='error' />
                </Tooltip>}
                <ExportJedzButtons demandId={demandId} dealingId={dealingId} setConfirmPopupData={setConfirmPopupData} />
                <Tooltip title={open ? Tr('collapse') : Tr('expand')} placement='top'>
                    <ArrowIcon
                        onClick={() => setOpen(!open)}
                        className={clsx(classes.arrow, classes.cursorPointer, {
                            [classes.rotate]: open
                        })}
                    />
                </Tooltip>
            </GridBlock>
            {open &&
            <div
                className={
                    clsx(classes.padding)}
            >
                {children}
            </div>
            }
            <Divider/>
        </Paper>
    )
}

DealingJedzSection.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(DealingJedzSection);